export default __webpack_public_path__ + "static/media/historyIcon.86f7753f.svg";